import React from 'react'
import { FiAlertOctagon } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'
import { Divider, Label, ToastWrapper } from '../../Toasts'
import { is } from '../../MediaQuery'

function ErrorBar() {
  const { t } = useTranslation()
  const isDesktop = is.desktop()
  return (
    <ToastWrapper
      style={{
        background: '#f70011',
        borderRadius: '3px',
        flexWrap: 'unset',
        height: '45px',
      }}
    >
      <FiAlertOctagon
        size={20}
        style={{ margin: '0px 20px', minHeight: '20px', minWidth: '20px' }}
      />
      <Divider />
      <Label style={{ fontSize: isDesktop ? '14px' : '13px' }}>
        {t('limits_end_header').replace('\\n', '')}
      </Label>
    </ToastWrapper>
  )
}

export default ErrorBar
